"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = void 0;
exports.capitalize = function (text) { return text.charAt(0).toUpperCase() + text.slice(1); };
//# sourceMappingURL=capitalize.js.map